import RepositoryFactory from "../../admin/apis/index";
const RSU = RepositoryFactory.rsu;

export default {
  addResource({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await RSU.addResource(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getResource({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await RSU.getResource(payload);
        console.log(data, "data record");
        commit("RSU_RECORD", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getDBData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await RSU.getDBData(payload);
        console.log(data, "khhjhbj");
        commit("SET_DB_DATA", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getStorageData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await RSU.getStorageData(payload);
        console.log(data, "khhjhbj");
        commit("SET_STORAGE_DATA", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
